import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { EmptyState } from '@/components/feedback/EmptyState'
import { Card } from '@/components/ui/Card'
import { PageHeader } from '@/components/layout/PageHeader'

export function NotFoundPage() {
  const { t } = useTranslation()

  return (
    <>
      <PageHeader title={t('notFound.title')} />
      <Card>
        {/* Never say "the record does not exist" — a 404 is returned for both
            missing and not-owned, so existence is not leaked either way. */}
        <EmptyState
          title={t('notFound.heading')}
          description={t('notFound.description')}
          action={
            <Link to="/" className="text-[13px]">
              {t('common.actions.back')}
            </Link>
          }
        />
      </Card>
    </>
  )
}
